export const Zero = 0
export const One = 1
export const Two = 2
export const Three = 3
export const Four = 4
export const Five = 5
export const Six = 6
export const Seven = 7
export const Eight = 8
export const Nine = 9
export const Ten = 10
export const Eleven = 11
export const Twelve = 12
export const Thirteen = 13
export const Fourteen = 14
export const Fifteen = 15
export const Sixteen = 16
export const SevenTeen = 17
